import { useEffect, useState } from 'react';

import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';

import { AgentDesignFlowForm } from 'components/agent/agent-design-flow-form';
import { AgentDesignFlowSelect } from 'components/agent/agent-design-flow-select';

const AgentDesignFlow = ({
	open,
	setOpen,
	initialView = 'select',
	selectedId,
	onSelect,
	libraryOnly = true,
	canManageResources = true,
	onCreate = null,
	onUpdate = null,
	initialModel = null,
	closeAfterSave = false,
	projectLocal = false,
}) => {
	const [view, setView] = useState(initialView);
	const [model, setModel] = useState(null);
	const [selection, setSelection] = useState(null);

	// Hooks
	useEffect(() => {
		if (open) {
			setModel(initialModel);
			setSelection(null);
			setView(initialView);
		}
	}, [initialModel, initialView, open]);

	// Methods
	const onClose = () => setOpen(false);
	const onCreated = async design => {
		if (closeAfterSave) return onClose();
		setSelection(design);
		setModel(null);
		setView('select');
	};
	const onEdit = design => {
		setModel(design);
		setView('form');
	};

	// Render
	return (
		<Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DialogContent variant='form' className='sm:max-w-2xl'>
				{view === 'select' ? (
					<AgentDesignFlowSelect
						selectedId={selection?.id || selectedId}
						onClose={onClose}
						onAdd={() => {
							setModel(null);
							setView('form');
						}}
						onEdit={onEdit}
						onSelect={setSelection}
						onSave={async () => {
							await onSelect(selection, true);
							onClose();
						}}
						canSave={Boolean(selection && selection.id !== selectedId)}
						libraryOnly={libraryOnly}
						canManageResources={canManageResources}
					/>
				) : canManageResources ? (
					<AgentDesignFlowForm
						model={model}
						onPrev={() => setView('select')}
						onNext={onCreated}
						onCreate={onCreate}
						onUpdate={onUpdate}
						projectLocal={projectLocal}
					/>
				) : null}
			</DialogContent>
		</Dialog>
	);
};

export { AgentDesignFlow };
